export default {
  'back-ios': require('./back-ios.svg'),
  calendar: require('./calendar.svg'),
  cancellation: require('./cancellation.svg'),
  'chekbox-disabled': require('./checkbox-disabled.svg'),
  checkmark: require('./checkmark.svg'),
  clock: require('./clock.svg'),
  'credit-card-amex': require('./credit-card-amex.svg'),
  'credit-card-default': require('./credit-card-default.svg'),
  'credit-card-mastercard': require('./credit-card-mastercard.svg'),
  'credit-card-visa': require('./credit-card-visa.svg'),
  disclosure: require('./disclosure.svg'),
  facebook: require('./facebook.svg'),
  'forward-ios': require('./forward-ios.svg'),
  hamburger: require('./hamburger.svg'),
  instagram: require('./instagram.svg'),
  location: require('./location.svg'),
  mask: require('./mask.svg'),
  'minus-small': require('./minus-small.svg'),
  person: require('./person.svg'),
  phone: require('./phone.svg'),
  play: require('./play.svg'),
  'play-video': require('./play-video.svg'),
  'plus-small': require('./plus-small.svg'),
  search: require('./search.svg'),
  soho: require('./soho.svg'),
  'soho-light': require('./soho-light.svg'),
  'soho-works': require('./soho-works.svg'),
  star: require('./star.svg'),
  tickets: require('./tickets.svg'),
  twitter: require('./twitter.svg'),
  wallet: require('./wallet.svg'),
  'x-large': require('./x-large.svg'),
  'x-small': require('./x-small.svg'),
  info: require('./info.svg')
}
